var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toaster sticky"},[_c('div',{staticClass:"fixed",class:_vm.currentBreakpoint === 'mobile' ? 'mt-4 mr-6' : 'right-0',style:(_vm.showForMimic || _vm.showForOrgTree ? 'marginTop:40px' : '')},_vm._l((_vm.toasts),function(toast,k){return _c('VinToast',{key:k,attrs:{"toast":toast}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }